import { Alert } from 'antd';
import { InfoCircleFilled } from '@ant-design/icons';

import './style.scss';

const About: React.FC = () => {
    return (
        <div className="trust-about-container">
            <Alert
                className="trust-about-alert"
                message={
                    <div>
                        <InfoCircleFilled className="info-icon" />
                        {__('Things you need to know about your Trusted Contact')}
                    </div>
                }
                description={
                    <div>
                        <p className="trust-about">
                            {__(`1. What are the reasons we might contact your trusted contact person ? `)}
                        </p>
                        <p className="trust-about">
                            {__(`· Addressing possible financial exploitation or fraud in your account.`)}
                        </p>
                        <p className="trust-about">
                            {__(`· Confirming your current contact information if we cannot reach you. `)}
                        </p>
                        <p className="trust-about">
                            {__(
                                '· Confirming your current health status, if we suspect you are sick or suffering from diminished capacity.'
                            )}
                        </p>
                        <p className="trust-about">
                            {__(
                                '· Confirming the identity of any legal guardian, trustee or holder of a power of attorney on your contact.'
                            )}
                        </p>
                        <p className="trust-about">
                            {__(
                                '2. The trusted contact(s) will NOT be able to view your account information, execute transactions, or inquire about account activity.'
                            )}
                        </p>
                    </div>
                }
            />
        </div>
    );
};

export default About;
